<script>
    export let src = null;
    export let tenantKey = '';
    export let hasVideo;
    export let alt = '';
    export let fillContainer = false;
</script>

<style>
    .image-container {
        position: relative;
    }
    .image {
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--no-media-color);
        width: 100%;
        height: 11.5rem;
        object-fit: cover;
        border-radius: .9rem;
    }

    .image .media-fallback {
        width: 4rem;
        height: 4rem;
    }

    .image--fill {
        width: 100%;
        height: 100%;
    }
    .video-icon {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        box-shadow: 0 0 16px 0 rgb(65 65 90 / 15%);
    }
</style>

{#if (src)}

    <div class="image-container">
        <object class="image {fillContainer ? 'image--fill' : ''}"
                data="https://patico-qr-test.s3.eu-west-3.amazonaws.com/{tenantKey}/_media_files/_196/{src}"
                type="image/png">
            <img class="media-fallback"
                 src="./images/fallback-image.svg"
                 alt={alt}>
        </object>

        {#if (hasVideo)}
            <img class="video-icon" src="./images/video.svg" alt="{alt}">
        {/if}
    </div>


{:else }

    <div class="image {fillContainer ? 'image--fill' : ''}">
        <img class="media-fallback"
             src="./images/fallback-image.svg"
             alt={alt}>
    </div>

{/if}
